import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useFieldsDashboard } from '/@/hooks/dashboards';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import { getNodeScopeFilters, type NodeScopeFilters } from '/@/utils/node-scope';
import DashboardCard from '../../../../../components/bayer/dashboard-card';
import { getCrops } from '../../../hooks/crops';

const FieldsByCropDashboardCard = ({
    userNodeId,
    nodeScope = getNodeScopeFilters('myFields'),
    rows = 1,
}: {
    userNodeId: number;
    nodeScope?: NodeScopeFilters;
    rows?: number;
}) => {
    const country = useSelector(getSessionCountry);
    const fieldsDashboardQuery = useFieldsDashboard({
        country: country.code,
        node: userNodeId,
        ...nodeScope,
    });
    console.log(rows);

    const crops = getCrops();

    return (
        <DashboardCard title={_('Distribución de cultivos')}>
            {fieldsDashboardQuery.isValidating ? (
                <Stack direction='row' spacing={2} justifyContent='start' flexWrap='wrap' useFlexGap>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Stack key={`crop-skeleton-${index}`} spacing={1} direction='column' alignItems='start'>
                            <Stack direction='row' spacing={0.5} alignItems='center'>
                                <Skeleton variant='circular' width={16} height={16} />
                                <Skeleton variant='text' width={40} />
                            </Stack>
                            <Skeleton variant='text' width={60} />
                        </Stack>
                    ))}
                </Stack>
            ) : (
                <Box
                    sx={{
                        height: '100%',
                        display: 'grid',
                        gridTemplateRows: 'repeat(2, 1fr) !important',
                        gridAutoFlow: 'column',
                        gap: 1,
                    }}
                >
                    {Object.values(crops).map((crop) => {
                        return (
                            <Stack key={crop.value} spacing={1} direction='column' alignItems='start' flexWrap='nowrap'>
                                <Stack direction='row' spacing={0.5} alignItems='center'>
                                    <Stack>{crop.getChip({ text: '' })}</Stack>
                                </Stack>
                                <Typography variant='h6' color='primary'>
                                    {_('{{count}} Lote', {
                                        count:
                                            fieldsDashboardQuery.data?.countByCrop?.[crop.value as keyof CountByCrop] ||
                                            0,
                                    })}
                                </Typography>
                            </Stack>
                        );
                    })}
                </Box>
            )}
        </DashboardCard>
    );
};

export default FieldsByCropDashboardCard;
